/**
 * Ref-counted document scroll lock for modals/overlays.
 * Locks both html + body (body-only overflow:hidden misses many browsers / iOS).
 * Uses position:fixed on body so mobile Safari cannot scroll the page behind.
 */
const CLASS = 'event-card-pdf-open';

let lockCount = 0;
let savedScrollY = 0;

export function pushDocumentScrollLock() {
  if (lockCount === 0) {
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add(CLASS);
    document.body.classList.add(CLASS);
    document.body.style.position = 'fixed';
    document.body.style.top = `-${savedScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }
  lockCount += 1;
}

export function popDocumentScrollLock() {
  if (lockCount <= 0) return;
  lockCount -= 1;
  if (lockCount !== 0) return;
  document.documentElement.classList.remove(CLASS);
  document.body.classList.remove(CLASS);
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';
  window.scrollTo(0, savedScrollY);
}
